import { ReactElement } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '~/components';
import { TIME_MASK } from '~/helpers/maskInputs';
import { DamScheduleFormValues } from '../../types';
import { ControlledInput } from '../Input';
import { TimeRowContainer } from './styles';

export function TimeRow(): ReactElement {
  const { control, setValue, getValues } = useFormContext<DamScheduleFormValues>();
  const { t } = useTranslation();

  const fullDayWatch = useWatch<DamScheduleFormValues, 'fullDay'>({
    control,
    name: 'fullDay',
  });

  function handleFullDayCheckbox(): void {
    const currentValue = fullDayWatch;

    if (currentValue) {
      setValue('startTime', '');
      setValue('endTime', '');
    } else {
      setValue('startTime', '00:00');
      setValue('endTime', '23:59');
    }

    setValue('fullDay', !currentValue);
  }

  function onChangeTime(): void {
    const startTime = getValues('startTime');
    const endTime = getValues('endTime');
    const fullDay = getValues('fullDay');

    if (!fullDay && startTime === '00:00' && endTime === '23:59') {
      setValue('fullDay', true);
      return;
    }

    if (fullDay && (startTime !== '00:00' || endTime !== '23:59')) {
      setValue('fullDay', false);
    }
  }

  return (
    <TimeRowContainer>
      <div>
        <ControlledInput
          name="startTime"
          placeholder={t('de')}
          label={t('de')}
          mask={TIME_MASK}
          onChange={onChangeTime}
        />
      </div>
      <div>
        <ControlledInput
          name="endTime"
          placeholder={t('ate')}
          label={t('ate')}
          mask={TIME_MASK}
          onChange={onChangeTime}
        />
      </div>
      <div>
        <Checkbox
          label={t('24horas')}
          checked={fullDayWatch}
          onClick={handleFullDayCheckbox}
          tabIndex={0}
        />
      </div>
    </TimeRowContainer>
  );
}
